import { type FunctionComponent } from 'react';

export type ModelProps = {
	modelNumber: string;
	fontSize?: 'f6' | 'f7';
	truncate?: boolean;
	className?: string;
	automationHook?: string;
};

export const Model: FunctionComponent<ModelProps> = ({ modelNumber, fontSize = 'f6', truncate = true, className = '', automationHook }) => {
	return (
		<div className={`lh-title theme-grey ${fontSize} ${truncate ? 'truncate' : ''} ${className}`} data-automation={automationHook}>
			Model: {modelNumber}
		</div>
	);
};
